var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.5,
    clipRule: "evenodd",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.94,
    cy: 36.34,
    r: 5,
    fill: "none",
    className: "stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    fill: "none",
    d: "M32.25 57.21a4.98 4.98 0 018.16-4.37 5 5 0 01-3.63 8.82"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 37.94,
    cy: 16.34,
    r: 5,
    className: "stroke fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.d5b5582807dc1393b685d59090db9439.svg";
export { ForwardRef as ReactComponent };